const assetStatuses = {
	NEW: 'New',
	ACTIVE: 'Active',
};

export default assetStatuses;
